import React, { useEffect, useState } from "react";

// import components
import AccountSettings from '../components/AccountSettings';
import LoginHistory from '../components/AccountSettings/LoginHistory';
import ProfileModal from '../components/AccountSettings/ProfileModal';
import ChangePassword from '../components/AccountSettings/ChangePassword';
import FooterNew from "../components/Footer-New";
import NavbarInner from "../components/Navbar-Inner.js";
import NavbarInnerSide from "../components/NavbarInnerSide.js";
import Sidebar from "../components/Sidebar.js";



export default function AccountPage() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  return (
    <div>
    
      {/* <NavbarInner /> */}
      <NavbarInnerSide toggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)} />
      <div className="flex w-full relative">
        <Sidebar isOpen={isSidebarOpen} closeSidebar={() => setIsSidebarOpen(false)} />
        <div className="flex-1 w-full overflow-hidden p-4">
          <AccountSettings />
          <LoginHistory />
        </div>
      </div>
      {/* <FooterNew /> */}
      {/* <NavbarFixed /> */}
      <ProfileModal />
      <ChangePassword />
    </div>
  );
}
